module.exports = __webpack_public_path__ + "static/media/onestop_img1.03fd7f30.jpg";